import React from "react";
import { useTranslation } from "react-i18next";

interface HeaderTypes {
  className?: string;
}

export default function PublicFooter(props: HeaderTypes) {
  const { className } = props;
  const { t } = useTranslation();

  return (
    <footer className="w-full h-32 justify-between text-gray-white bg-primary-130 flex items-center px-4">
      <div className={"flex gap-x-3"}>
        <img width={200} src={"/samaLogo.png"} />
      </div>
      <div className={"flex flex-col items-end h-full justify-end pb-4"}>
        <p className={"text-base"}>{t("versioning")}</p>
        <div className={"flex gap-x-2"}>
          <span className={"text-base"}>{t("allRightReserved")}</span>
          <span className={"text-base"}>{t("reservedYear")}</span>
        </div>
      </div>
    </footer>
  );
}
